<script setup lang="ts">
import { computed } from 'vue'
import LoadingModal from '@/components/LoadingModal.vue'

interface Props {
	loading?: boolean
	creating?: boolean
	swapping?: boolean
	canceling?: boolean
	paying?: boolean
	resuming?: boolean
}

const props = defineProps<Props>()

const isActive = computed(() =>
	props.loading ||
	props.creating ||
	props.swapping ||
	props.canceling ||
	props.paying ||
	props.resuming
)

const message = computed(() => {
	if (props.swapping) return 'Procesando cambio de plan…'
	if (props.creating) return 'Activando suscripción…'
	if (props.paying) return 'Procesando pago…'
	if (props.canceling) return 'Cancelando suscripción…'
	if (props.resuming) return 'Reactivando suscripción…'
	return 'Cargando…'
})
</script>

<template>
	<LoadingModal :when="isActive" :message="message" />
</template>
